<template>
  <div>
    <FullCalendar ref="fullCalendar"  :options="calendarOptions" />
  </div>
</template>
 
<script>
import BasePage from "@/pages/Admin/BasePage";
import FullCalendar from "@fullcalendar/vue";
import roLocale from "@fullcalendar/core/locales/ro";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import tippy from 'tippy.js';
// import 'tippy.js/themes/light.css';
import moment from 'moment';

export default {
  extends: BasePage,
  components: {
    FullCalendar,
  },
  watch: {
    Programari(val) {
      this.calendarOptions.events = val;
    },
  },
  props: {
    Programari: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  data() {

    var formateaza = (d) =>{
      let km=`<tr>
                <td>Km:</td>
                <td>`+d.Km+`</td>
              </tr>`;

    let ceva = `
      <div  class='wmain-container'>
        <div class='whalf-container'>
          <div style="background-color:white; font-size: 13px; border-radius:10px; border: 0.2px solid black; padding:10px;">
            <table>
              <tr align="center" ><th colspan="2">Masina #`+d.IdMasina +`</th></tr>
              `+marca_model(d)+`
              `+an_masina(d.Km)+`
              `+kilometraj(d.Km)+`
              <tr  align="center" ><th style="padding-top:10px;" colspan="2">Client #` + d.IdClient + `</th></tr>
                <tr>
                  <td>Nume / prenume:</td>
                  <td>`+d.NumeClient+` `+d.PrenumeClient+`</td>
                </tr>
                `+idEvioClient(d)+`
                <tr>
                  <td>Email:</td>
                  <td>`+d.EmailClient+`</td>
                </tr> 
                <tr>
                  <td>Telefon:</td>
                  <td>`+d.TelefonClient+`</td>
                </tr> 

                <tr align="center" ><th style="padding-top:10px;" colspan="2">Programare #`+d.Id+ `</th></tr>
                <tr>
                  <td>Data rezervarii:</td>
                  <td>`+this.$options.filters.DataOraFaraSec(d.DataRezervarii)+`</td>
                </tr>  
                <tr>
                  <td>Data adaugare:</td>
                  <td>`+this.$options.filters.DataOraFaraSec(d.DataAdaugare)+`</td>
                </tr> 
                <tr>
                  <td>Cantitate:</td>
                  <td>`+d.Cantitate+`</td>
                </tr>  
                <tr>
                  <td>Durata (min):</td>
                  <td>`+d.DurataMin+`</td>
                </tr>
                <tr>
                  <td>Status:</td>
                  <td>`+d.Status+`</td>
                </tr>
                  `+Observatii(d.Observatii)+`
                  `+NumeAgent(d.NumeAgent)+` 
               
                  `+deviz(d)+` 
            
          </div>
        </div>
      </div>`;

      return ceva
      

    };
    
    var deviz = (d) =>{
      let raspuns = '';

      if(d.IdDeviz != null) {
        raspuns= `
                <tr>
                  <tr align="center" ><th style="padding-top:10px;" colspan="2">Deviz #`+d.IdDeviz+ `</th></tr>
                </tr>
                <tr>
                  <td>Status deviz:</td>
                  <td><span style="color:white; padding:2px; border-radius: 5px;background:`+d.eventBackgroundColor+`;"> `+d.StatusDeviz+` </span></td>
                </tr>
                `;
        if(d.FaraFactura != '0'){
          raspuns += `

                <tr>
                  <td><span style="color:white; padding:2px; border-radius: 5px;background:`+d.eventBackgroundColor+`;"> Inchis fara factura </span></td>
                </tr>
                `;
        }
         if(d.TipAnvelope != null){
          raspuns +=`

                <tr>
                  <td>Tip anvelope:</td>
                  <td>`+d.TipAnvelope+`</td>
                </tr>`;
         }    
         if(d.Antifurt != null){
          raspuns +=`

                <tr>
                  <td>Antifurt:</td>
                  <td>`+this.$options.filters.DaNu(d.Antifurt)+`</td>
                </tr>`;
         }    
         if(d.DataPreluareInLucru != null){
          raspuns +=`
                <tr>
                  <td>Data preluare in lucru:</td>
                  <td>`+this.$options.filters.DataOraFaraSec(d.DataPreluareInLucru)+`</td>
                </tr>`;
         }         
         if(d.DataTerminareLucru != null){
          raspuns +=`
                <tr>
                  <td>Data terminare lucru:</td>
                  <td>`+this.$options.filters.DataOraFaraSec(d.DataTerminareLucru)+`</td>
                </tr>`;
         } 
         if(d.DataFacturare != null){
          raspuns +=`
                <tr>
                  <td>Data facturare:</td>
                  <td>`+this.$options.filters.DataOraFaraSec(d.DataFacturare)+`</td>
                </tr> 
                <tr>
                  <td>Id factura:</td>
                  <td>`+d.IdFactura+`</td>
                </tr>
                `;
         }  
         
         if( d.PresiuneRoti >0){
          raspuns +=`
                <tr>
                  <td>Presiune roti fata:</td>
                  <td>`+d.PresiuneRoti+`</td>
                </tr>
                `;
         }    
         
         if( d.PresiuneRotiSpate >0){
          raspuns +=`
                <tr>
                  <td>Presiune roti spate:</td>
                  <td>`+d.PresiuneRotiSpate+`</td>
                </tr>
                `;
         }
         
         if( d.Cuplu >0){
          raspuns +=`
                <tr>
                  <td>Cuplu (fata):</td>
                  <td>`+d.Cuplu+`</td>
                </tr>
                `;
         }     
         
         if (d.CupluSpate != null && d.CupluSpate !== '' && d.CupluSpate > 0) {
          raspuns +=`
                <tr>
                  <td>Cuplu (spate):</td>
                  <td>`+d.CupluSpate+`</td>
                </tr>
                `;
         }else if(d.Cuplu >0){
          raspuns +=`
                <tr>
                  <td>Cuplu (spate):</td>
                  <td>`+d.Cuplu+`</td>
                </tr>
                `;
         }  
         
         if( d.MotivStergere != ''){
          raspuns +=`
                <tr>
                  <td>Motiv stergere:</td>
                  <td>`+d.MotivStergere+`</td>
                </tr>
                `;
         }

         raspuns += `
        </table> `
            ;
         
         
            if (d.StareRoti != null) {
              const items = JSON.parse(d.StareRoti).filter((item) => item.index >= 0);

              // Verifică dacă există vreun element cu `janta_avariata`
              const existaJantaAvariata = items.some((element) => element.janta_avariata);

              if (existaJantaAvariata) {
                // Construiește un nou tabel pentru roțile cu jante avariate
                raspuns += `
                <table style="font-size:11px">
                  <tr>
                    <th style="padding-top:10px!important; font-weight:450">Roata</th>
                    <th style="padding-top:10px!important; font-weight:450">Verificata</th>
                    <th style="padding-top:10px!important; font-weight:450">Janta Avariata</th>
                    <th style="padding-top:10px!important; font-weight:450">Aspect janta</th>
                    <th style="padding-top:10px!important; font-weight:450">Stare anvelopa</th>
                    <th style="padding-top:10px!important; font-weight:450">Diametru initial</th>
                    <th style="padding-top:10px!important; font-weight:450">Diametru final</th>
                  </tr>  
                  `;

                items.forEach(element => {
                  if (element.janta_avariata) { // Doar elementele cu janta avariata
                    raspuns += `
                    <tr>
                      <td align="center" style=" width:10%">` + parseInt(parseInt(element.index) + 1) + `</td>
                      <td align="center" style=" width:16%">` + this.$options.filters.DaNu(element.verificata) + `</td>
                      <td align="center" style=" width:25%">` + this.$options.filters.DaNu(element.janta_avariata) + `</td>
                      <td align="center" style=" width:23%">` + element.starea_jantei + `</td>
                      <td align="center" style=" width:27%">` + (element.starea_anvelopei && element.starea_anvelopei !== '' ? element.starea_anvelopei : '-') + `</td>
                      <td align="center" style="width:15%">` + (element.diametru_initial ?? '-') + `</td>
                      <td align="center" style="width:15%">` + (element.diametru_final ?? '-') + `</td>
                    </tr>`;
                  }
                });

                raspuns += `</table>`;
              } else {
                // Continuă cu tabelul original
                raspuns += `
                <table style="font-size:11px">
                  <tr>
                    <th style="padding-top:10px!important; font-weight:450">Roata</th>
                    <th style="padding-top:10px!important; font-weight:450">Verificata</th>
                    <th style="padding-top:10px!important; font-weight:450">Aspect janta</th>
                    <th style="padding-top:10px!important; font-weight:450">Deformare janta</th>
                    <th style="padding-top:10px!important; font-weight:450">Stare anvelopa</th>
                    <th style="padding-top:10px!important; font-weight:450">Diametru initial</th>
                    <th style="padding-top:10px!important; font-weight:450">Diametru final</th>
                  </tr>  
                  `;

                items.forEach(element => {
                  raspuns += `
                  <tr>
                    <td align="center" style="width:8%">` + (parseInt(element.index) + 1) + `</td>
                    <td align="center" style="width:16%">` + this.$options.filters.DaNu(element.verificata) + `</td>
                    <td align="center" style="width:22%">` + element.starea_jantei + `</td>
                    <td align="center" style="width:28%">` + element.deformari_jante + `</td>
                    <td align="center" style="width:27%">` + (element.starea_anvelopei && element.starea_anvelopei !== '' ? element.starea_anvelopei : '-') + `</td>
                    <td align="center" style="width:15%">` + (element.diametru_initial ?? '-') + `</td>
                    <td align="center" style="width:15%">` + (element.diametru_final ?? '-') + `</td>
                  </tr>`;
                });

                raspuns += `</table>`;
              }
            }

      }
      return raspuns;

    };    
    
    
    var kilometraj = (km) =>{
      let raspuns = '';

      if(typeof km != 'undefined') {
        raspuns= `
              <tr>
                <td>Km:</td>
                <td>`+Km+`</td>
              </tr>
              `;
      }
      return raspuns;

    }; 
    
    var idEvioClient = (d) =>{
      let raspuns = '';
      if(d.IdClientEvio != null) {
        raspuns= `
              <tr>
                <td>Id client Evio:</td>
                <td>`+d.IdClientEvio+`</td>
              </tr>
              `;
      }
      return raspuns;

    };
    
    var marca_model = (d) =>{
      let raspuns = '';

      if( d.Marca != null) {
        raspuns= `
              <tr>
                <td>Marca si model:</td>
                <td>`+d.Marca
              ;
      }
      if(d.Model != null) {
        raspuns += ` - ` +d.Model;
      }
      raspuns += `</td>
              </tr>`;
      return raspuns;

    };
    
    var an_masina = (an) =>{
      let raspuns = '';

      if(an != null && an > 0) {
        raspuns= `
              <tr>
                <td>Km:</td>
                <td>`+An+`</td>
              </tr>
              `;
      }
      return raspuns;

    };    
    var NumeAgent = (agent) =>{
      let raspuns = '';

      if(agent != null && agent != '') {
        raspuns= `
              <tr>
                <td>Agent:</td>
                <td>`+agent+`</td>
              </tr>
              `;
      }
      return raspuns;

    };
    
    var Observatii = (obs) =>{
      let raspuns = '';

      if(obs != null && obs != '') {
        raspuns= `
              <tr>
                <td>Observatii:</td>
                <td>`+obs+`</td>
              </tr>
              `;
      }
      return raspuns;

    };
    return {
      calendarOptions: {
    
        nowIndicator: true,
        height: '100vh',
        scrollTimeReset: false,
        // scrollTime: "09:30:00",
        // slotMinTime: "00:00:00",
        // slotMaxTime: "00:00:00",
        hiddenDays: [],
        slotDuration: "00:30:00",
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: "dayGridMonth",
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        locale: roLocale,
        // buttonText: {
        //   today: "Azi",
        //   month: "Luna",
        //   week: "Saptamana",
        //   day: "Zi",
        //   list: "Lista",
        // },

        slotEventOverlap: false,
        eventDisplay: 'block',
        dateClick: this.handleDateClick,
        datesSet: this.handleIntervalChange,
        eventClick: this.handleEventClick,
        events: this.Programari,
        firstDay: 1,
        // editable: true,
        // eventStartEditable:true,
        // eventChange:this.handleEventChange,
        aspectRatio: 4,
        eventTimeFormat: { hour: "2-digit", minute: "2-digit", hour12: false },
        displayEventTime: true,
        // timeFormat: {hour: '2-digit',minute: '2-digit',hour12: false},

        eventDidMount: function (info) {
          // console.log(info.event.extendedProps)
            tippy(info.el, {
            delay: 500, // ms
            arrow: true,
            placement: "bottom",
            content: formateaza(info.event.extendedProps),

           
            allowHTML: true
          });


          
            // <div style="background-color:white; width:100%; font-size:12px;box-sizing: border-box;">
           
          



      // var tooltip = new Tooltip(info.el, {
      //   title: "info.event.extendedProps.description",
      //   placement: 'top',
      //   trigger: 'hover',
      //   container: 'body'
      // });


          var dotEl = info.el.getElementsByClassName("fc-event-dot")[0];
          if (dotEl) {
            dotEl.style.backgroundColor = "red";
          }
        },
      },
    };
  },
  methods: {

    // handleDayClick: function (arg) {
    //   alert(1)
    // },    
    handleDateClick: function (arg) {
      this.$emit("programareNoua", arg.dateStr);
    },

    handleIntervalChange(e){
      let start   = moment((e.start)).format('YYYY-MM-DD');
      let end     = moment((e.end)).format('YYYY-MM-DD');
      this.$emit('handleIntervalChange', {start: start, end: end});
    },

    handleEventClick: function (arg) {
      this.$emit("editProgramare", JSON.stringify(arg.event));
    },
    async resizeHandler() {
      let calendarApi = this.$refs.fullCalendar.getApi();

      if (window.innerWidth < 768) {
        this.calendarOptions.headerToolbar.right = "";
        await calendarApi.changeView("timeGridDay");
        await this.$nextTick();

      } else {
        this.calendarOptions.headerToolbar.right =
          "dayGridMonth,timeGridWeek,timeGridDay";
        await calendarApi.changeView("dayGridMonth");
        await this.$nextTick();
      }
    },
    async get_info_program(){
      var response            = await this.post("admin/setari/index" );

      this.calendarOptions.slotMinTime = response.Setari.OraStartCalendar;
      this.calendarOptions.slotMaxTime = response.Setari.OraStopCalendar;

      if (response.Setari.SeLucreazaS == 0) {
        this.calendarOptions.hiddenDays.push(6);
      } else {
        if (response.Setari.OraStartS < this.calendarOptions.slotMinTime) this.calendarOptions.slotMinTime = response.Setari.OraStartS;
        if (response.Setari.OraStopS > this.calendarOptions.slotMaxTime) this.calendarOptions.slotMaxTime = response.Setari.OraStopS;
      }

      if (response.Setari.SeLucreazaD == 0){
        this.calendarOptions.hiddenDays.push(0);
      } else {
        if (response.Setari.OraStartD < this.calendarOptions.slotMinTime) this.calendarOptions.slotMinTime = response.Setari.OraStartD;
        if (response.Setari.OraStopD  > this.calendarOptions.slotMaxTime) this.calendarOptions.slotMaxTime = response.Setari.OraStopD;
      }

      // if (response.Setari.DurataProgramare > 0 && response.Setari.DurataProgramare <= 60){
      //   this.calendarOptions.slotDuration = "00:" + response.Setari.DurataProgramare + ":00";
      // }

      this.calendarOptions.slotDuration = "00:30:00";

    },
  },
  async mounted() {
    await this.get_info_program();
    let calendarApi = this.$refs.fullCalendar.getApi();
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.calendarOptions.headerToolbar.right = "";
      await calendarApi.changeView("timeGridDay");

		  await this.$nextTick();
    }
  },

  created() {
    window.addEventListener("resize", this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
  },
};
</script>

<style scoped>
.comp-full-calendar {
  width: auto !important;
}





</style>